import { CommunicationChannelUseItemDto } from "@hd/types/dto/communication/communication-channel-use.dto";
import { ConversationChannelType } from "@hd/types/dto/shared/enums/conversation-channel-type";

export interface ChannelOption {
  id: ConversationChannelType;
  labelKey: string;
}

export interface ChannelSelectModel {
  options: ChannelOption[];
  disabledIds: ConversationChannelType[];
  preselectedIds: ConversationChannelType[];
}

const CHANNEL_LABEL_KEY: Record<ConversationChannelType, string> = {
  [ConversationChannelType.HoteldoorChat]:
    "communicationsModal.channelName.hoteldoorChat",
  [ConversationChannelType.Email]: "communicationsModal.channelName.email",
  [ConversationChannelType.WhatsApp]:
    "communicationsModal.channelName.whatsApp",
};

const isKnownChannel = (
  channelId: number,
): channelId is ConversationChannelType => channelId in CHANNEL_LABEL_KEY;

/**
 * Le voci del dropdown canali partono da quello che dice l'api: ordine del payload,
 * canale assente = niente voce. Le label le traduce il chiamante.
 */
export function buildChannelSelectModel(
  use?: CommunicationChannelUseItemDto[] | null,
): ChannelSelectModel {
  const options: ChannelOption[] = [];
  const disabledIds: ConversationChannelType[] = [];
  const preselectedIds: ConversationChannelType[] = [];

  for (const item of use || []) {
    if (!isKnownChannel(item.channelId)) continue;
    // se l'api ripete un canale non voglio due voci uguali (chiavi React duplicate)
    if (options.some((option) => option.id === item.channelId)) continue;

    options.push({
      id: item.channelId,
      labelKey: CHANNEL_LABEL_KEY[item.channelId],
    });

    if (!item.sendAvailable) {
      disabledIds.push(item.channelId);
    } else if (item.sendDefault) {
      preselectedIds.push(item.channelId);
    }
  }

  return { options, disabledIds, preselectedIds };
}
